document.addEventListener('DOMContentLoaded', function() {
  // Selektoren für die Elemente
  const widthInput = document.getElementById('svgWidth');
  const heightInput = document.getElementById('svgHeight');
  const sizeSelect = document.getElementById('product-grosse-template--19688728887536__main');
  
  // Plus/Minus Buttons für Breite
  const widthPlusButton = widthInput.parentElement.querySelector('.plus');
  const widthMinusButton = widthInput.parentElement.querySelector('.minus');
  
  // Plus/Minus Buttons für Höhe
  const heightPlusButton = heightInput.parentElement.querySelector('.plus');
  const heightMinusButton = heightInput.parentElement.querySelector('.minus');
  
  // Variable, um den letzten Zustand zu speichern
  let lastVariant = null;
  
  // Array für Varianten aus dem Select-Element erstellen
  const sizeVariants = [];
  Array.from(sizeSelect.options).forEach(option => {
    const dimensions = option.value.split(' x ');
    const width = parseFloat(dimensions[0]);
    const height = parseFloat(dimensions[1]);
    
    sizeVariants.push({
      option: option,
      width: width,
      height: height
    });
  });
  
  // Funktion zum Finden der besten Variante für die gegebenen Maße
  function findBestVariant(userWidth, userHeight) {
    // Sicherstellen, dass die Werte gültig sind
    userWidth = parseFloat(userWidth);
    userHeight = parseFloat(userHeight);
    
    if (isNaN(userWidth) || isNaN(userHeight)) {
      return null;
    }
    
    // Die kleinste Variante finden, die die Maße abdeckt
    let bestVariant = null;
    let bestArea = Infinity;
    
    sizeVariants.forEach(variant => {
      // Nur Varianten berücksichtigen, die groß genug sind
      if (variant.width >= userWidth && variant.height >= userHeight) {
        const area = variant.width * variant.height;
        if (area < bestArea) {
          bestVariant = variant;
          bestArea = area;
        }
      }
    });
    
    // Falls keine passende Variante gefunden wurde, nimm die größte verfügbare
    if (!bestVariant) {
      bestVariant = sizeVariants.reduce((largest, current) => {
        const largestArea = largest.width * largest.height;
        const currentArea = current.width * current.height;
        return currentArea > largestArea ? current : largest;
      }, sizeVariants[0]);
    }
    
    return bestVariant;
  }
  
  // Funktion zum Aktualisieren der ausgewählten Variante
  function updateSelectedVariant() {
    const userWidth = widthInput.value;
    const userHeight = heightInput.value;
    
    const bestVariant = findBestVariant(userWidth, userHeight);
    
    if (bestVariant) {
      // Prüfen, ob die Variante geändert wurde
      const variantString = `${bestVariant.width} x ${bestVariant.height}`;
      const lastSelectedValue = sizeSelect.value;
      const currentVariantValue = bestVariant.option.value;
      
      // Nur aktualisieren, wenn es sich geändert hat
      if (lastSelectedValue !== currentVariantValue) {
        // Variante auswählen
        sizeSelect.value = bestVariant.option.value;
        
        // Ein Change-Event auslösen, damit der Shop die Änderung registriert
        const event = new Event('change', { bubbles: true });
        sizeSelect.dispatchEvent(event);
        
        // Aktualisierung nur loggen, wenn eine tatsächliche Änderung vorliegt
        console.log(`Variante geändert zu: ${variantString} cm`);
        
        // Aktuellen Zustand speichern
        lastVariant = bestVariant;
      }
    }
  }
  
  // Kontinuierliche Überwachung der Eingabefelder mit MutationObserver
  const inputObserverConfig = { attributes: true, childList: false, subtree: false };
  
  // Observer für Breite
  const widthObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'value' || mutation.attributeName === 'min' || mutation.attributeName === 'max') {
        updateSelectedVariant();
      }
    });
  });
  
  // Observer für Höhe
  const heightObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'value' || mutation.attributeName === 'min' || mutation.attributeName === 'max') {
        updateSelectedVariant();
      }
    });
  });
  
  // Observer starten
  widthObserver.observe(widthInput, inputObserverConfig);
  heightObserver.observe(heightInput, inputObserverConfig);
  
  // Event Listener für die Eingabefelder (zusätzlich zu MutationObserver)
  ['input', 'change', 'keyup', 'blur', 'focus'].forEach(eventType => {
    widthInput.addEventListener(eventType, updateSelectedVariant);
    heightInput.addEventListener(eventType, updateSelectedVariant);
  });
  
  // Event Listener für die Plus/Minus Buttons
  widthPlusButton.addEventListener('click', function() {
    const currentValue = parseFloat(widthInput.value) || 0;
    const step = parseFloat(widthInput.step) || 0.1;
    const max = parseFloat(widthInput.getAttribute('maxvalue')) || 220;
    
    if (currentValue + step <= max) {
      widthInput.value = (currentValue + step).toFixed(1);
      updateSelectedVariant();
    }
  });
  
  widthMinusButton.addEventListener('click', function() {
    const currentValue = parseFloat(widthInput.value) || 0;
    const step = parseFloat(widthInput.step) || 0.1;
    const min = parseFloat(widthInput.getAttribute('minvalue')) || 9.5;
    
    if (currentValue - step >= min) {
      widthInput.value = (currentValue - step).toFixed(1);
      updateSelectedVariant();
    }
  });
  
  heightPlusButton.addEventListener('click', function() {
    const currentValue = parseFloat(heightInput.value) || 0;
    const step = parseFloat(heightInput.step) || 0.1;
    const max = parseFloat(heightInput.getAttribute('maxvalue')) || 110;
    
    if (currentValue + step <= max) {
      heightInput.value = (currentValue + step).toFixed(1);
      updateSelectedVariant();
    }
  });
  
  heightMinusButton.addEventListener('click', function() {
    const currentValue = parseFloat(heightInput.value) || 0;
    const step = parseFloat(heightInput.step) || 0.1;
    const min = parseFloat(heightInput.getAttribute('minvalue')) || 15;
    
    if (currentValue - step >= min) {
      heightInput.value = (currentValue - step).toFixed(1);
      updateSelectedVariant();
    }
  });
  
  // Polling mit reduzierter Häufigkeit
  const pollInterval = setInterval(function() {
    updateSelectedVariant();
  }, 2000); // Von 500ms auf 2000ms erhöht
  
  // Initialisierung beim Laden der Seite
  updateSelectedVariant();
  
  // Event-Listener für Formular-Änderungen
  document.querySelector('form').addEventListener('change', function(event) {
    updateSelectedVariant();
  });
  
  // Event-Listener für benutzerdefinierte Events
  document.addEventListener('productSizeChanged', function(event) {
    updateSelectedVariant();
  });
});